<mat-icon class="generic-error__icon">error</mat-icon>
<p class="generic-error__title">
  {{ text | translate }}
</p>
